import React, { useMemo } from 'react';
import { SyutSelect } from 'components/ui';
import { useDrill } from 'contexts/DrillContext';
import type { DrillDimension } from 'contexts/DrillContext';

const DIMENSION_LABELS: Record<string, string> = {
  Employee: 'Employee', Manager: 'Manager', Engagement: 'Engagement',
  Client: 'Client', EngagementType: 'Engagement Type', Activity: 'Activity',
  ChargeType: 'Charge Type', WorkDate: 'Work Date', Entry: 'Individual Entries',
};

export const SyutDrillSelector: React.FC = () => {
  const { state, changeDrillBy, availableDimensions } = useDrill();

  const options = useMemo(
    () => availableDimensions.map(d => ({ value: d, label: DIMENSION_LABELS[d] || d })),
    [availableDimensions],
  );

  if (options.length === 0) return null;

  return (
    <div className="syut-drill-selector">
      <span className="drill-by-label">Drill By:</span>
      <div style={{ minWidth: 160 }}>
        <SyutSelect
          value={state.currentGroupBy}
          options={[
            { value: state.currentGroupBy, label: DIMENSION_LABELS[state.currentGroupBy] || state.currentGroupBy },
            ...options,
          ]}
          onChange={(val) => {
            if (val && val !== state.currentGroupBy) {
              changeDrillBy(val as DrillDimension);
            }
          }}
          isClearable={false}
          size="sm"
        />
      </div>
    </div>
  );
};

export default SyutDrillSelector;
